import { createContext } from 'react';
import type { ScatterClassIconType, ScatterStudentIconType } from '../components/charts/types';

export type IconsType = {
  studentIcons: ScatterStudentIconType
  classesIcons: ScatterClassIconType
  chevronIcons: {
    chevronUp: Node
    chevronDown: Node
  },
  chartIcon: Node,
  smileyIcons: {
    bad: Node,
    good: Node,
    excellent: Node,
  },
  collapseIcons: {
    collapseOn: Node
    collapseOff: Node
  },
};

export const IconContext = createContext<IconsType | null>(null);
